import React from 'react';
import PropTypes from 'prop-types'

const Html = ({ children }) => {
    return <div dangerouslySetInnerHTML={{__html: children }} ></div>

}

export default Html;